import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import CountDown from './CountDown';
import './ApplyTitleHeader.css';
import { checkIsMobile } from '../../utils/deviceUtils';
// import { sectorImages } from '../../constants/images';

const ApplyTitleHeader = ({ title, onClick }) => {
  const [isMobile, setIsMobile] = useState(checkIsMobile(window.innerWidth));

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      setIsMobile(checkIsMobile(width));
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className="apply-title-header" onClick={onClick} style={{ cursor: onClick ? 'pointer' : 'default' }}>
      <h1>
        {title.map((line, index) => (
          <span key={index}>{line}</span>
        ))}
      </h1>
      <CountDown 
        showTitle={false}
        isMobile={isMobile}
        // titleImage={sectorImages.sectorApply.title[isMobile ? 'mobile' : 'pc']}
      />
    </div>
  );
};

ApplyTitleHeader.propTypes = {
  title: PropTypes.arrayOf(PropTypes.string).isRequired,
  onClick: PropTypes.func
};

export default ApplyTitleHeader; 